export default __webpack_public_path__ + "static/media/23.64726ae3.jpg";